import React, { Component } from 'react';
import { DownloadBrochure } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class DownloadBrochureView extends Component {

	render () {
		const {
			buttonLabel,
			fileName,
		} = this.props.content.landingPage.downloadBrochure;
		return (
			<DownloadBrochure
				{...{
					buttonLabel,
					fileName,
				}}
			/>
		);
	}

}

export default withLanguageContext(DownloadBrochureView);



// WEBPACK FOOTER //
// ./src/components/views/DownloadBrochureView/DownloadBrochureView.js